import React from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';
import ListViewLayout from '../../layout/ListViewLayout';
import DetailLayout from '../../layout/DetailLayout';
import EditLayout from '../../layout/EditLayout';

const OBJECT_NAME = 'email_template';

/** Redirect /listview/email_template to /setup/emailtemplate */
export const RedirectEmailTemplateList = () => <Navigate to="/setup/emailtemplate" replace />;

/** Redirect /view/email_template/:id to /setup/emailtemplate/:id */
export const RedirectEmailTemplateView = () => {
  const { id } = useParams();
  return <Navigate to={`/setup/emailtemplate/${id}`} replace />;
};

/** Redirect /edit/email_template or /edit/email_template/:id to setup emailtemplate create or edit */
export const RedirectEmailTemplateEdit = () => {
  const { id } = useParams();
  if (id) return <Navigate to={`/setup/emailtemplate/${id}/edit`} replace />;
  return <Navigate to="/setup/emailtemplate/create" replace />;
};

/**
 * Email Template list under Setup — same as /listview/email_template but at /setup/emailtemplate.
 */
export const SetupEmailTemplateList = () => {
  const location = useLocation();
  return <ListViewLayout objectName={OBJECT_NAME} location={location} />;
};

/**
 * Email Template detail under Setup — same as /view/email_template/:id but at /setup/emailtemplate/:id.
 */
export const SetupEmailTemplateView = ({ socket, selectedWhatsAppSetting }) => {
  const { id } = useParams();
  return (
    <DetailLayout
      objectName={OBJECT_NAME}
      id={id}
      socket={socket}
      selectedWhatsAppSetting={selectedWhatsAppSetting}
    />
  );
};

/**
 * Email Template edit under Setup — same as /edit/email_template/:id but at /setup/emailtemplate/:id/edit.
 */
export const SetupEmailTemplateEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  let sourcePage = 'listview';
  if (location.state?.sourcePage) sourcePage = location.state.sourcePage;
  else if (document.referrer?.includes('/view/')) sourcePage = 'detail';
  const searchParams = new URLSearchParams(location.search);
  const targetfield = searchParams.get('targetfield');
  const targetid = searchParams.get('targetid');
  const queryParams = targetfield && targetid ? { targetField: targetfield, targetId: targetid } : null;
  return (
    <EditLayout
      objectName={OBJECT_NAME}
      id={id}
      sourcePage={sourcePage}
      queryParams={queryParams}
    />
  );
};
